import React, {Component} from 'react';
import RaportyService from "../../RaportyService";
import {HorizontalGridLines, LabelSeries, VerticalBarSeries as BarSeries, VerticalGridLines, XAxis, XYPlot, YAxis} from "react-vis/es/index";
import acc from 'accounting'
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";

export default class RozliczenieKursyKierowcyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dane: [],

        };
    }

    componentDidMount() {
        this.pobierzDaneDoRaportu(this.props.daty)
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.daty)) {
            this.pobierzDaneDoRaportu(nextprops.daty)
        }
    }

    pobierzDaneDoRaportu(daty) {
        RaportyService.pobierzSzczegoloweRozliczenieKursowKierowcy(daty[0],daty[1]).then(function (response) {
            let arr = Array.from(response.data,item=>{
                return{
                    ...item,
                    'imieNazwisko':item.imie+' '+item.nazwisko
                }
            })
           this.setState({dane:arr})
        }.bind(this))
    }

    render() {

        return (
            <div>
                <div>
                    <XYPlot width={1600} height={300}  xType="ordinal" getX={d => d.imie[0]+'. '+d.nazwisko} getY={d => d.sumWartosc} margin={{top:10,bottom:100}}>
                        <VerticalGridLines/>
                        <HorizontalGridLines/>
                        <XAxis tickLabelAngle={-60}/>
                        <YAxis title={'Wartość [zł]'}/>
                        <BarSeries data={this.state.dane} color={'#83c33a'}/>
                        <LabelSeries data={this.state.dane} getLabel={d => acc.formatMoney(d.sumWartosc)} style={{fontSize:'10px'}} rotation={-5}/>
                    </XYPlot>
                </div>
                <div>
                    <BootstrapTable data={this.state.dane}
                                    hover
                    >
                        <TableHeaderColumn dataField='idKi' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='imieNazwisko' dataSort
                                           thStyle={tabgrid.tg17} tdStyle={tabgrid.tg17}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Kierowca</TableHeaderColumn>
                        <TableHeaderColumn dataField='sumWartosc' dataSort
                                           thStyle={tabgrid.tg8} tdStyle={tabgrid.tg8}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell,row)=>{return acc.formatMoney(cell)}}
                        >Suma wartości</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczenieKursow/Kierowcy/RozliczenieKursyKierowcyContainer.js